import { Action } from '@ngrx/store';
import { Node } from '@alfresco/js-api';

export const DOCUMENT_EXPIRE_ACTION = 'DOCUMENT_EXPIRE_ACTION';

export class DocumentExpireAction implements Action {
  readonly type = DOCUMENT_EXPIRE_ACTION;
  constructor(public payload: Node) {}
}
